module.exports = __webpack_public_path__ + "static/who-are-we-c72762c19c8c330f11c01299d5371941.svg";